export default __webpack_public_path__ + "static/media/close-teal.1ce7aa43.svg";